<!-- 教育培训详情页 -->
<template>
  <div class="container">
    <login-navigator></login-navigator>
    <logo-header></logo-header>
    <main-navigator :currentIndex="currentIndex"></main-navigator>
    <section class="bread">
        <span class="index">首页</span><span>&gt;</span><span class="current">教育培训</span>
    </section>
    <section class="main">
        <div class="main-content" id="main">
          <div class="introduce">
            <h2>{{desObject.company}}</h2>
            <p class="price">参考价格:<span style="color:red;">电话咨询</span></p>
            <p class="mark">以父母之心育人，帮助学生成才</p>
            <p>开班日期：<span>电话咨询</span></p>
            <p>上课班制：<span>电话咨询</span></p>
            <p>咨询热线：<span style="color:red;">{{desObject.phone}}</span></p>
          </div>
          <div class="des-wrap">
            <div class="title">课程详情</div>
            <div class="name">{{desObject.company}}</div>
            <div class="des" id="des">
              {{desObject.dec}}
            </div>
          </div>
        </div>
    </section>
  </div>
</template>

<script>
import LoginNavigator from "../components/LoginNavigator";
import LogoHeader from "../components/LogoHeader";
import Bread from "../components/Bread";
import MainNavigator from "../components/MainNavigator";
import qs from "qs";
export default {
  data() {
    return {
      currentIndex: 1,
      listIndex: 0,
      desObject: {}
    };
  },

  components: {
    Bread,
    LoginNavigator,
    LogoHeader,
    MainNavigator
  },
  created() {
    this.listIndex = parseInt(this.$route.query.id);
  },
  mounted() {
    this.getInfoId();
  },
  methods: {
    getInfoId: function() {
      var that = this,
        id = this.listIndex;
      var postData = {
        id: id
      };
      that.$axios
        .post("http://imgurl120.moontion.cn/cyy/wy/employ/index.php/Employ/getInfoId", qs.stringify(postData))
        .then(function(res) {
          that.desObject = res.data.info;
        });
    }
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  background: #f5f5f5;
}
.bread {
  width: 1200px;
  height: 57px;
  line-height: 57px;
  margin: 0 auto;
  background: #fff;
}
.bread .index {
  margin-left: 24px;
}
.bread span {
  font-size: 12px;
  color: #333;
}
.bread .current {
  color: #00a0e9;
}
.main {
  width: 1200px;
  padding-top: 9px;
  margin: 0 auto;
  background: #fff;
}
.main-content {
  padding: 15px;
}
.main-content h2 {
  margin-bottom: 20px;
}
.main-content p {
  margin-bottom: 20px;
}
.main-content .title {
  margin-bottom: 12px;
}

.main-content .tag {
  color: gray;
}
.main-content p > span {
  color: gray;
}
.des-wrap {
  margin-top: 60px;
}
.des-wrap .title {
  padding: 20px 0;
  border-bottom: 1px solid #999;
  color: #999;
}
.des-wrap .name {
  margin-top: 20px;
  text-align: center;
}
.des-wrap .des {
  word-wrap: normal;
  margin-top: 40px;
  font-size: 16px;
  line-height: 30px;
  padding: 0 40px 60px 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/EducationDetail.vue